export default __webpack_public_path__ + "static/media/alert-neutral-variation.bfab5e6e.svg";